import forEach from 'lodash.foreach';
import lSportsService from '../../../services/lSportsService';

//InPlay
export const INPLAY_START_LOADING = '[APP] INPLAY START LOADING';
export const INPLAY_SET_EVENTS = '[APP] INPLAY SET EVENTS';
export const ON_INPLAY_SPORT_SELECTED = '[APP] ON NPLAY SPORT SELECTED';
export const ON_INPLAY_SEARCH = '[APP] ON INPLAY SEARCH';
export const ON_INPLAY_LOCATION_SELECTED = '[APP] ON INPLAY LOCATION SELECTED';
export const ON_INPLAY_RESET_SELECTED_LOCATIONS = '[APP] ON INPLAY RESET SELECTED LOCATIONS';
export const INPLAY_SET_ACTIVE_MATCH_ID = '[APP] INPLAY SET ACTIVE MATCH ID';
export const ON_INPLAY_MAIN_MARKET_SELECTED = '[APP] ON INPLAY MAIN MARKET SELECTED';
export const ON_INPLAY_REMOVE_LEAGUE = '[APP] ON INPLAY REMOVE LEAGUE';
export const SET_INPLAY_LEAGUE_EVENTS = '[APP] SET INPLAY LEAGUE EVENTS';

export const startLoading = (desiredLoadCount) => {
    return (dispatch, getState) => {
        dispatch({
            type: INPLAY_START_LOADING,
            desiredLoadCount: desiredLoadCount,
        });
    };
};

export const setLeagueEvents = (events) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_INPLAY_LEAGUE_EVENTS, events: events });
    };
};

export const getLeagueEvents = (sportId, locationId, leagueId) => {
    return (dispatch, getState) => {
        lSportsService
            .inplayGetLeagueEvents(sportId, locationId, leagueId)
            .then((events) => {
                dispatch(setLeagueEvents(events));
            })
            .catch((error) => {
                console.error(error);
            });
    };
};

export const loadEventsInChunks = (data) => {
    return (dispatch, getState) => {
        forEach(data, (sport) => {
            forEach(sport.Locations, (location) => {
                forEach(location.Leagues, (league) => {
                    dispatch(getLeagueEvents(sport.Id, location.Id, league.Id));
                });
            });
        });
    };
};

export const getAllEvents = () => {
    return (dispatch, getState) => {
        lSportsService
            .inPlayGetEvents(1)
            .then((events) => {
                dispatch(setEvents(events));
            })
            .catch((error) => {
                console.error(error);
            });
    };
};

export const getEvents = (lang) => {
    return (dispatch, getState) => {
        lSportsService
            .inPlayGetEvents(0)
            .then((events) => {
                dispatch(getAllEvents(events));
                dispatch(setEvents(events));
            })
            .catch((error) => {
                console.error(error);
            });
    };
};

export const setEvents = (events) => {
    return (dispatch, getState) => {
        dispatch({ type: INPLAY_SET_EVENTS, events: events });
    };
};

export const selectSport = (sportId) => {
    return (dispatch, getState) => {
        dispatch({ type: ON_INPLAY_SPORT_SELECTED, sportId: sportId });
    };
};

export const search = (value) => {
    return (dispatch, getState) => {
        let { originEvents } = getState().lSports.inplay;
        if (originEvents) {
            dispatch({ type: ON_INPLAY_SEARCH, search: value });
        }
    };
};

export const selectLocation = (locationId) => {
    return (dispatch, getState) => {
        dispatch({ type: ON_INPLAY_LOCATION_SELECTED, locationId: locationId });
    };
};

export const resetSelectedLocations = (locationId) => {
    return (dispatch, getState) => {
        dispatch({ type: ON_INPLAY_RESET_SELECTED_LOCATIONS });
    };
};

export const setActiveMatchId = (matchId) => {
    return (dispatch, getState) => {
        dispatch({ type: INPLAY_SET_ACTIVE_MATCH_ID, matchId: matchId });
    };
};

export const selectMainMarket = (sportId, marketId) => {
    return (dispatch, getState) => {
        dispatch({
            type: ON_INPLAY_MAIN_MARKET_SELECTED,
            sportId: sportId,
            marketId: marketId,
        });
    };
};

export const removeLeague = (sportId, locationId, leagueId) => {
    return (dispatch, getState) => {
        let { originEvents } = getState().lSports.inplay;
        if (originEvents) {
            dispatch({
                type: ON_INPLAY_REMOVE_LEAGUE,
                sportId: sportId,
                locationId: locationId,
                leagueId: leagueId,
            });
        }
    };
};

export function mapLSportsInplayDispatchToProps(dispatch) {
    return {
        inplay: {
            startLoading: (desiredLoadCount) => {
                dispatch(startLoading(desiredLoadCount));
            },
            getEvents: (lang) => {
                dispatch(getEvents(lang));
            },
            selectSport: (sportId) => {
                dispatch(selectSport(sportId));
            },
            search: (value) => {
                dispatch(search(value));
            },
            selectLocation: (locationId) => {
                dispatch(selectLocation(locationId));
            },
            resetSelectedLocations: () => {
                dispatch(resetSelectedLocations());
            },
            setActiveMatchId: (matchId) => {
                dispatch(setActiveMatchId(matchId));
            },
            selectMainMarket: (sportId, marketId) => {
                dispatch(selectMainMarket(sportId, marketId));
            },
            removeLeague: (sportId, locationId, leagueId) => {
                dispatch(removeLeague(sportId, locationId, leagueId));
            },
        },
    };
}
